// src/pages/ComoFunciona.jsx
import React from "react";

const ComoFunciona = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">¿Cómo funciona QRBenefits?</h1>
      <p className="text-secondary mb-4">
        Descubrí cómo aprovechar al máximo los beneficios, descuentos y puntos de QRBenefits.
      </p>

      <ol className="fs-5">
        <li className="mb-3">
          <strong>Descubrí beneficios:</strong> escaneá un código QR en tu comercio favorito o ingresá desde tu perfil.
        </li>
        <li className="mb-3">
          <strong>Activá el beneficio:</strong> revisá las condiciones y activalo desde la web.
        </li>
        <li className="mb-3">
          <strong>Mostrá el código en el local:</strong> el comercio lo valida y se aplica el descuento.
        </li>
        <li className="mb-3">
          <strong>Sumá puntos:</strong> cada beneficio que usás te suma puntos y desbloquea badges.
        </li>
      </ol>
    </div>
  );
};

export default ComoFunciona;
